/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EInvoiceIdentifierType } from './';
import {
    EInvoiceIdentifierTypeFromJSON,
    EInvoiceIdentifierTypeFromJSONTyped,
    EInvoiceIdentifierTypeToJSON,
} from './';

/**
 * E-invoice routing identifier for a client legal entity. Present only when a routing is configured; its absence on the legal entity means the default (SIREN) applies.
 * @export
 * @interface EInvoiceRouting
 */
export interface EInvoiceRouting {
    /**
     * 
     * @type {EInvoiceIdentifierType}
     * @memberof EInvoiceRouting
     */
    identifierType: EInvoiceIdentifierType;
    /**
     * Free-text suffix, only meaningful when identifierType is ROUTING_SUFFIX
     * @type {string}
     * @memberof EInvoiceRouting
     */
    routingSuffix?: string;
}

/**
 * Check if a given object implements the EInvoiceRouting interface.
 */
export function instanceOfEInvoiceRouting(value: object): value is EInvoiceRouting {
    if (!('identifierType' in value) || value['identifierType'] === undefined) return false;
    return true;
}

export function EInvoiceRoutingFromJSON(json: any): EInvoiceRouting {
    return EInvoiceRoutingFromJSONTyped(json, false);
}

export function EInvoiceRoutingFromJSONTyped(json: any, ignoreDiscriminator: boolean): EInvoiceRouting {
    if (json == null) {
        return json;
    }
    return {
        
        'identifierType': EInvoiceIdentifierTypeFromJSON(json['identifierType']),
        'routingSuffix': json['routingSuffix'] == null ? undefined : json['routingSuffix'],
    };
}

export function EInvoiceRoutingToJSON(value?: EInvoiceRouting | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identifierType': EInvoiceIdentifierTypeToJSON(value['identifierType']),
        'routingSuffix': value['routingSuffix'],
    };
}

